
function capitalizeFirstWord(str: string): string {
  return str.replace(/^\w/, c => c.toUpperCase())
}

export const capitalizeName = (name: string): string => {
  if (name.includes('-')) {
    const names = name.split('-')
    const capNames: string[] = []
    for (let i = 0; i < names.length; i++) {
      capNames.push(capitalizeFirstWord(names[i]))
    }
    return capNames.toString().replace(',', '-')
  } else {
    return capitalizeFirstWord(name)
  }
}

export const deleteAllLineEndings = (str: string): string => {
  return str.replace(/(?:\r\n|\r|\n)/g, '')
}

export function removeUnit(val: string): string {
  if (val.includes('px') === true) {
    val = val.replace('px', '')
  }
  return val
}
